/* stylelint-disable selector-type-case, selector-list-comma-newline-after, no-descending-specificity */
import styled, { css } from 'styled-components';
import { BorderBottom } from '../../../src/styled/shared-styles';
import { StyleButtonBase } from '../button-base';
import { StyledListItemContent } from '../list-item-content/styled';
import { StyledListItemIcon } from '../list-item-icon/styled';
import { getSizeBy, getColorShade, getColor } from '../../../src/styled/utils';
export const StyledListItemOverlay = styled.span `
  position: absolute;
  inset: 0;
  transition-duration: 200ms;
  transition-property: background-color;
`;
export const StyledSelectedListItem = css `
  color: ${getColor('primary')};

  & > ${StyledListItemContent}, & > ${StyledListItemIcon} > svg {
    color: ${getColor('primary')};
  }

  & > ${StyledListItemOverlay} {
    background-color: ${getColorShade('primary', 'selected')};
  }
`;
export const StyledListItem = styled.li `
  ${StyleButtonBase};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  cursor: ${({ $button }) => $button && 'pointer'};
  pointer-events: ${({ $disabled, $button }) => $disabled && $button && 'none'};
  ${({ $divider }) => $divider && BorderBottom}

  &:last-of-type {
    border: 0;
  }
`;
const StyledButtonListItem = css `
  &:active > ${StyledListItemContent}, &:active > ${StyledListItemIcon} > svg {
    color: ${getColor('primary')};
  }

  &:hover > ${StyledListItemOverlay} {
    background-color: ${getColorShade('primary', 'hover')};
  }

  &:focus {
    outline: none;
  }

  &:focus > ${StyledListItemOverlay} {
    background-color: ${getColorShade('primary', 'focused')};
  }

  &:active > ${StyledListItemOverlay} {
    background-color: ${getColorShade('primary', 'pressed')};
  }
`;
export const StyledMainContentWrap = styled.div `
  position: relative;
  display: flex;
  flex-grow: 1;
  align-items: center;
  padding: ${getSizeBy(2)} ${getSizeBy(3)};
  padding-right: ${({ $hasSecondAction }) => $hasSecondAction && getSizeBy(12.5)};
  ${({ $button, $selected }) => $button && $selected && StyledSelectedListItem};

  & > ${StyledListItemIcon} > svg {
    color: ${({ $disabled, $button }) => $disabled && $button && getColorShade('onSurface', 'outline')};
  }

  & > ${StyledListItemContent} {
    color: ${({ $disabled, $button }) => $disabled && $button && getColorShade('onSurface', 'lowEmphasis')};
  }

  ${({ $button }) => $button && StyledButtonListItem};
`;
